import React from 'react';
import './Complete.css'; 
function SubmitComplete() {
  return (
    <div className="submit-complete wrapper">
      <h1>確認メールを送信しました。</h1>
      <div class="SC_h1">
        <h1>メールをご確認ください。</h1>
      </div>
    </div>
  );
}

export default SubmitComplete;
